export default class Evolucao {
  static MATRICULA = {
    CURSANDO: 6,
    CONCLUINTE: 15,
    CERTIFICADO: 16,
    TRANSFERIDO: 20,
    TRANCADO: 21,
    SEM_RENOVACAO: 25,
    RETORNADO: 26,
    CANCELADO: 27,
    FORMADO: 81,
    DIPLOMADO: 82,
    EGRESSO: 89,
  };

  getString(id) {
    return (
      {
        // MATRICULA
        6: 'Cursando',
        15: 'Concluinte',
        16: 'Certificado',
        20: 'Transferido',
        21: 'Trancado',
        25: 'Sem Renovação',
        26: 'Retornado',
        27: 'Cancelado',
      }[id] || ''
    );
  }
}
